<template>
  <b-row class="mb-1">
    <b-col>
      <b-row>
        <b-col cols="12">
          <b-table
            :items="servicos"
            :fields="pacote.descontoPacote ? colunas : colunas.filter(fil => fil.key != 'descontoPacote')"
            class="tabela-pacote-honorarios"
            bordered
            foot-clone
          >
            <template #thead-top>
              <b-tr>
                <b-th colspan="4">
                  <span>{{ pacote ? pacote.nome : '' }}</span>
                  <b-button
                    size="sm"
                    style="width: 21%;float: right;"
                    :class="pacoteSelecionado? 'btn-primary' : 'btn-light'"
                    @click="escolherPacote"
                  >
                    {{ pacoteSelecionado? 'Pacote contratado' : 'Contratar esse pacote' }}
                    <font-awesome-icon
                      :class="'text-light'"
                      :icon="pacoteSelecionado? faThumbsUp : faHandPointUp "
                      style="font-size:16px !important;width:20px;"
                    />
                  </b-button>
                </b-th>

              </b-tr>
            </template>

            <template #cell(servicoPacote)="{ item }">
              <span>{{ item.nome }}</span>
            </template>
            <template #cell(valorAuditar)>
              <span />
            </template>
            <template #cell(subTotal)>
              <span />
            </template>

            <template #foot(servicoPacote)="">
              <span>SubTotal</span>
            </template>
            <template #foot(valorAuditar)="">
              <span class="valor-total-servico-pacote">{{ valorTotalAuditar | converteValor }}</span>
            </template>
            <template #foot(descontoPacote)="">
              <span
                v-if="pacote && !porcentagem && pacote.descontoPacote"
                class="valor-total-servico-pacote"
              >{{ pacote.descontoPacote | converteValor }}</span>
              <span v-else-if="pacote && pacote.descontoPacote">{{ pacote.descontoPacote }}%</span>
              <span
                v-else
                class="valor-total-servico-pacote"
              >{{ 0 | converteValor }}</span>
            </template>
            <template #foot(subTotal)="">
              <span
                class="valor-total-servico-pacote"
                style="max-width: 300px; word-break: break-all;"
              >{{ valorSubtotal | converteValor }}</span>
            </template>
            <template #table-caption>
              <span v-if="pacote">{{ pacote.observacao || '' }}</span>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.tabela-pacote-honorarios {
  background-color: #e1e1e1 !important;
  .form-control {
    padding: 0.438rem 0.7rem;
    height: 2.5rem;
  }

  th {
    background-color: #e1e1e1 !important;
  }

  th,
  td {
    padding: 0.5rem 0.2rem;
  }
}

.valor-total-servico-pacote {
  // justify-content: flex-end;
  font-size: 13.2px;
}

.cor-fundo {
  background-color: #ffffff !important;
}
</style>

<script>
import {
  faHandPointUp, faThumbsUp,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'TabelaPacoteHonorario',
  components: {
    FontAwesomeIcon,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    escolhido: {
      type: Boolean,
      default: false,
    },
    porcentagem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      faHandPointUp,
      faThumbsUp,
      colunas: [
        {
          key: 'servicoPacote', label: 'Serviços', thStyle: 'width: 418px;background-color: #f8f8f8 !important;padding: 0.5rem 0.2rem;', tdClass: 'cor-fundo',
        },
        {
          key: 'valorAuditar', label: 'Valor', thStyle: 'width: 149px; background-color: #f8f8f8 !important;padding: 0.5rem 0.2rem;', tdClass: 'cor-fundo',
        },
        {
          key: 'descontoPacote', label: 'Desconto', thStyle: 'width: 149px; background-color: #f8f8f8 !important;padding: 0.5rem 0.2rem;', tdClass: 'cor-fundo',
        },
        {
          key: 'subTotal', label: 'Subtotal', thStyle: 'width: 259px; background-color: #f8f8f8 !important;padding: 0.5rem 0.2rem;', tdClass: 'cor-fundo',
        },
      ],
      pacote: null,
      servicos: [],
      pacoteSelecionado: this.escolhido,
    }
  },
  computed: {
    valorTotalAuditar() {
      if (this.pacote && this.pacote.id > 0) {
        if (!this.porcentagem) {
          if (this.pacote.acrescimoPacote) {
            return this.pacote.valorPacote + this.pacote.acrescimoPacote
          }
          return this.pacote.valorPacote
        }
        if (this.pacote.acrescimoPacote && this.pacote.acrescimoPacote > 0) {
          return this.pacote.valorPacote + (this.pacote.valorPacote * (this.pacote.acrescimoPacote / 100))
        }
        return this.pacote.valorPacote
      }
      return 0
    },
    valorSubtotal() {
      if (this.pacote && this.pacote.id > 0) {
        if (!this.porcentagem) {
          let valor = this.pacote.valorPacote
          if (this.pacote.acrescimoPacote) {
            valor += this.pacote.acrescimoPacote
          }
          if (this.pacote.descontoPacote) {
            valor -= this.pacote.descontoPacote
          }
          return valor
        }
        let valor = this.pacote.valorPacote
        if (this.pacote.acrescimoPacote && this.pacote.acrescimoPacote > 0) {
          valor += valor * (this.pacote.acrescimoPacote / 100)
        }
        if (this.pacote.descontoPacote && this.pacote.descontoPacote > 0) {
          valor -= (valor * (this.pacote.descontoPacote / 100))
        }
        return valor
      }
      return 0
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.pacote = value
        this.carregarServicos()
      }
    },
    escolhido(value, oldValue) {
      if (value !== oldValue) {
        this.pacoteSelecionado = value
      }
    },
  },
  beforeMount() {
    this.pacote = this.value
    this.carregarServicos()
  },
  methods: {
    carregarServicos() {
      this.servicos = this.pacote.servicos
    },
    escolherPacote() {
      this.$emit('escolher-pacote', this.value)
    },
  },
}
</script>
